import { render } from "./RestablecerContrasena.vue?vue&type=template&id=40aacc12&scoped=true"
import script from "./RestablecerContrasena.vue?vue&type=script&lang=js"
export * from "./RestablecerContrasena.vue?vue&type=script&lang=js"

import "./RestablecerContrasena.vue?vue&type=style&index=0&id=40aacc12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aacc12"]])

export default __exports__